export const COOKIE_SETTINGS = {
    "AUTH_DURATION": 60*60*24*365
}